import { useStaticQuery, graphql } from "gatsby"

export const useGeneralSettings = () => {
    const { allContentfulGeneralSettings } = useStaticQuery(graphql`
        query GeneralSettings {
            allContentfulGeneralSettings {
                edges {
                    node {
                        optimizeContainerId
                        showHeaderScript
                        headerScript {
                            childMarkdownRemark {
                                html
                            }
                        }
                    }
                }
            }
        }
    `)
    return allContentfulGeneralSettings.edges
}
